import React, {useState} from 'react';
import './../../assets/css/login.css'
import SignInForm from './SigninForm';
import SignUpForm from './SignUpForm';
import im from '../../assets/images/logo.svg'
const Login = () => {
 const [type, setType] = useState("signIn");
  const handleOnClick = text => {
    if (text !== type) {
      setType(text);
      return;
    }
  };
  const containerClass =
    "container " + (type === "signUp" ? "right-panel-active" : "");
  return (
    <div className="App" style={{display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", padding: 165, top: '5%'}}>
      <div className={containerClass} id="container">
        <SignUpForm />
        <SignInForm />
        <div className="overlay-container" style={{background: "green"}}>
          <div className="overlay">
            <div className="overlay-panel overlay-left">
              <h1>Welcome Back!</h1>
              <p>
                To keep connected with us please login with your personal info
              </p>
              <button
                className="ghost"
                id="signIn"
                onClick={() => handleOnClick("signIn")}
              >
                Sign In
              </button>
            </div>
            <div className="overlay-panel overlay-right">
              <img src={im} style={{width: 300, marginTop: '-100px'}}/>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
